import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import React from 'react';
import { globalStyles } from "../../style/GlobalStyles";

export type MissinParametersProps = {
    campo: string;
    pagina: string;
}

export default function MissingParameters(props: MissinParametersProps) {
    const gClasses = globalStyles();
    return (
        <Paper className={gClasses.mainPaper} style={{ minHeight: "80vh", width: "80vw" }}>
            <Grid container spacing={0} justify="center" alignItems="center" direction="column" style={{ margin: "1rem" }}>
                <Grid item>
                    <Typography color="error" variant="h5" style={{ margin: "1rem" }}>Attenzione</Typography>
                </Grid>
                <Divider></Divider>
                <Grid item>
                    <Typography variant="h6">Per accedere a queste informazioni è necessario valorizzare il campo {props.campo} nella pagina</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="h5" color="primary">{props.pagina}</Typography>
                </Grid>
            </Grid>
            <Divider></Divider>
        </Paper>);
}